export default __webpack_public_path__ + "static/media/img_company_header21.3e13a189.png";